<template>
    <div class="Report__section">
        <button
            type="button"
            class="Report__section__title"
            @click="toggleExpansion"
        >
            <v-icon
                left
                small
                v-if="expanded"
            >
                fas fa-caret-down
            </v-icon>
            <v-icon
                left
                small
                v-else
            >
                fas fa-caret-right
            </v-icon>
            {{ section.name }}
        </button>
        <div
            v-if="section.cards && expanded"
            class="Report__cards"
        >
            <ReportCard
                v-for="(card, index) in section.cards"
                :key="index"
                :card="card"
                :section="section"
                :step="step"
            />
        </div>
    </div>
</template>

<script>
import ReportCard from '@/reports/ReportCard';
export default {
    components: { ReportCard },
    props: {
        section: {
            type: Object,
            required: true,
        },

        step: {
            type: Object,
            required: true,
        }
    },

    data() {
        return {
            expanded: true,
        };
    },

    mounted() {
        const exp = localStorage.getItem(`reportSection${this.section.name}expanded`);
        if (exp === 'false') {
            this.expanded = false;
        }
    },

    methods: {
        toggleExpansion() {
            this.expanded = !this.expanded;
            localStorage.setItem(`reportSection${this.section.name}expanded`, this.expanded ? 'true' : 'false');
        }
    }
};
</script>
<style lang="scss">
.Report__section {
    flex: 0 0 auto;
    width: 100%;
    margin-bottom: 24px;
}

.Report__section__title {
    display: flex;
    flex-flow: row wrap;
    flex: 0 0 100%;
    width: 100%;
    margin-bottom: 12px;
    font-size: 1.1rem;
    font-weight: 500;
}

.Report__cards {
    display: grid;
    grid-gap: 1rem;
    grid-template-columns: repeat(1, minmax(100%, 100%));

    @media (min-width: 768px) {
        grid-gap: 1.5rem;
        grid-template-columns: repeat(2, minmax(50%, 50%));
    }
}
</style>
